import { ArrowLeft } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconArrowLeft(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <ArrowLeft />
    </IconWrapper>
  );
}
